import script from "./SiderMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./SiderMenu.vue?vue&type=script&lang=ts&setup=true"

import "./SiderMenu.vue?vue&type=style&index=0&id=0de8d855&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0de8d855"]])

export default __exports__